import {
  Required,
  Schema,
  NumberField,
  RangeInc,
  SwitchField
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../../core/mainStore";
import i18next from "i18next";
import { HuntingGroupFK } from "../schema";
import { DestinationFK } from "../../destination/schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { BooleanSwitchField } from "../../../common/common";
import { Auth } from "../../../core/model/auth";

// @ts-ignore
const t = (...args: unknown[]): string => () => i18next.t(...args);

export const HuntingGroupMemberSchema = new Schema({
  fields: [
    {
      name: "position",
      title: t("hns:huntingGroupMember:position"),
      type: NumberField(Required, RangeInc(0, 2147483647)),
      sort: false
    },
    {
      name: "destinationRef",
      title: t("hns:destination:domain"),
      type: DestinationFK,
      sort: false
    },
    {
      name: "huntingGroupRef",
      title: t("hns:huntingGroup:domain"),
      type: HuntingGroupFK,
      readonly: true,
      sort: false
    },
    {
      name: "isActive",
      title: t("hns:huntingGroupMember:isActive"),
      type: BooleanSwitchField(Required),
      sort: false
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  }
});

export const HuntingGroupMemberSchemaColumns = HuntingGroupMemberSchema.extend({
  huntingGroupRef: false,
  isActive: {
    type: BooleanSwitchField(Required),
    title: t("hns:huntingGroupMember:isActive")
  }
});

mainStore.huntingGroupMember = RemoteChildDataSource.create({
  parent: mainStore.huntingGroup.oneDataSource,
  api: api,
  name: "huntingGroupMember",
  schema: HuntingGroupMemberSchema,
  url: "/members",
  commons: mainStore.commons
});
